import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import AirplayIcon from "@material-ui/icons/Airplay";
import React from "react";
import { languages } from "../../constants/languages";

export default class LiveLinkDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.tournament.liveLink}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText>
              <Typography variant="caption">
                {languages.tournament.liveLinkDescription}
              </Typography>
              <br />
            </DialogContentText>
            <TextField
              fullWidth
              autoFocus
              value={this.props.liveLink}
              onChange={this.props.handleLiveLinkChange}
              label={languages.tournament.liveLink}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    style={{ marginRight: 0, whiteSpace: "nowrap" }}
                  >
                    <AirplayIcon style={{ color: "gray", marginRight: 10 }} />
                    {this.props.tournament.isPSD || this.props.tournament.crqpsd
                      ? "tournify.prosoccerdata.com/"
                      : "tournifyapp.com/live/"}
                  </InputAdornment>
                ),
              }}
            />
          </DialogContent>
          {this.props.errorMessage && (
            <DialogActions>
              <div>
                <Typography style={{ color: "red" }}>
                  {this.props.errorMessage}
                </Typography>
              </div>
            </DialogActions>
          )}
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <div style={{ position: "relative" }}>
              <Button
                onClick={this.props.handleSubmit}
                variant="contained"
                color="primary"
                type="submit"
                disabled={this.props.checkingLiveLink}
              >
                {languages.general.save}
              </Button>
              {this.props.checkingLiveLink && (
                <CircularProgress
                  size={24}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: -12,
                    marginLeft: -12,
                  }}
                />
              )}
            </div>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
